import React from 'react';

export const About = () => (        //shortcut to not type a return
    <div>
        <h1>About Us</h1>
        <p>Created By: Alex Ma & Matt Narvano</p>
        <h2>Technologies Used</h2>
        <a href='https://github.com/facebook/create-react-app'>Creat-React-App</a> <br></br>
        <a href='https://react-bootstrap.github.io/'>React Bootstrap</a><br></br>
        <a href='https://reacttraining.com/react-router/'>React Router</a><br></br>
        <a href='https://coinmarketcap.com/api/'>CoinMarketCap API</a><br></br>
        <a href='https://newsapi.org/'>News API</a><br></br>
        <a href='https://chartkick.com/react'>Chartkick.js</a><br></br>
        <a href='https://github.com/jerairrest/react-chartjs-2'>React Chart.js</a><br></br>
        <a href='https://firebase.google.com/'>Firebase</a> <br></br>
        <a href='https://github.com/alexjmma/react-crypto-tracker'>Github Repo</a> <br></br>
        
 
        
    </div>
)